export default __webpack_public_path__ + "static/media/Footpad's Boots of the Sundered Crown.fdfc9066.jpg";